module.exports = __webpack_public_path__ + "img/login32.c0665259.png";